export class ReportBase {
    damages = [];
    is_main_report = false;
    report_type = 'user';
    uuid = crypto.randomUUID();
    constructor(base = {}) {
        Object.entries(base).forEach(([key, value]) => {
            this[key] = value ?? this[key];
        });
    }
}
